import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonUtility } from '@app/_modules/commonUtility';
import { CategoryService } from '@app/_services/category.service';
import { retryWhen } from 'rxjs/operators';

@Component({
  selector: 'app-fee-details',
  templateUrl: './fee-details.component.html'
})
export class FeeDetailsComponent implements OnInit {

  displayedColumns: string[] = ['Srno','Contract No','Customer Name','Paymeent Amount'];

  form: FormGroup;
  forms: FormGroup;
  JSON;
  isgPay_url:string;
  todayDate:Date;

  @ViewChild('txnForm') txnForm: any;
  tranxnForm : FormGroup;
  submitBtnMsg:String;
  submitBtnMsgClass:String = 'wrappper';
  commonUtility:CommonUtility;
  loading = false;
  name:any='';
  initialCap: any;
  submitted = false;
  fathersName:any='';
  courseLoader = false;
  course:any;
  semester:any;
  semesterList:any;
  source:any;
  type:any='';
  req : any;
  amount:any;
  row:any='';
  contractNo:any;
  panNo:any;
  customerName:any;
  totalAmount:any;
  contractName:any;
  myDIV: Boolean = false ;
  dataSource:any;
  disableSelect;
  totalFees:any;
  EncDataField:string;
  MerchantIdField:string;
  TransactionId:string;
  BankIdField:string;
  TerminalIdField:string;
  VersionField:string;
  showTable: Boolean = false ;
  totalDisabled:boolean=true;
  verified: boolean = false;
  isVerificationPending: boolean = true;
  isVerified: boolean = false;
  studentData:any;
  resStatusCode;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private categoryService: CategoryService
  ) {
    this.JSON=JSON;
    this.isgPay_url = categoryService.isgPay_url;
    this.commonUtility = this.categoryService.commonUtility;

   }
   maxValue(event)
   {
    if(event.target.value && event.target.max)
    {
      if((event.which != 8 && event.which != 46 && event.which != 37 &&event.which != 39 &&event.which != 9))
      {
          if(event.target.value.length>(<number>event.target.max-1))
        {
          event.preventDefault();
        }
      }
    }
   }
  ngOnInit(): void {
   
    this.todayDate = new Date();
    this.tranxnForm = this.formBuilder.group({
    Version:[''],
    TerminalId: [''],
    BankId: [''],
    MerchantId: [''],
    EncData:[''],
    TransactionId:['']

         });
      this.form = this.formBuilder.group({

        contractNo: ["",[Validators.required,Validators.pattern("^[A-Za-z0-9]+$")]],
        totalAmount: ["",[Validators.required, Validators.pattern("^[0-9]+$")]],
        captcha: ['', Validators.required]


      });
 
      this.Cap();
  }
  

  get f()
 { return this.form.controls; }

 fetchByContractNo(){
      console.log('in fetchByContractNo');
      console.log('this.form.invalid'+JSON.stringify(this.form.invalid));

      if (this.form.invalid ) {
         return;
        }
    

      this.loading =true;
      var req ={
          "contractNo":'BMW-'+this.form.controls.contractNo.value,
          };


      this.categoryService.fetchByContractNo(req).subscribe(res=>{

        console.log('req : '+JSON.stringify(req));

        console.log('res : '+JSON.stringify(res));
        if(res.body.statusCode === '00000'){

           this.resStatusCode = res.body.statusCode;
           this.studentData = res.body.data.bmwDetailsModel;
           this.verified = true;

        }
        else if(res.body.statusCode=="99998"){
          this.commonUtility.alertMsg('Contract No Not Found','',false);
        }

        
        }),(error)=>{
          alert(error);
        }

        this.isVerificationPending = false;
        this.isVerified = true;
         
      }
 
      submitContractDetails():void{

        var routeUrl;
        this.submitted = true;
      
      
        if(!this.form.controls.contractNo.value && !this.form.controls.totalAmount.value)
          {
            this.commonUtility.alertMsg('Please Enter Contract No & Contract Amount','',false);
          } 
        else if(!this.form.controls.totalAmount.value )
        {
          this.commonUtility.alertMsg('Please Enter Contract Amount ','',false);
        }
        else if(this.form.controls.totalAmount.value == 0){
          this.commonUtility.alertMsg('Contract Amount Should Not be Zero','',false);

        }
        else{
          if (this.form.invalid || (!this.ValidCaptcha())) {
            return;
        }
         
        this.loading =true;

        let req = {
          'contractNo': 'BMW-'+this.form.controls.contractNo.value,
          'totalAmount': this.form.controls.totalAmount.value,
          'source': "BMW",
          "captcha":this.form.controls.captcha.value
        };
      
        const encodedCaptcha = btoa(this.form.controls.captcha.value);
    
        this.categoryService.submitBmwDetails(req,encodedCaptcha).subscribe(res =>  {
          if(res.body.statusCode === "00000")
          {
           this.tranxnForm.controls.EncData.setValue(res.body.data.fields.EncData);
           this.tranxnForm.controls.MerchantId.setValue(res.body.data.fields.MerchantId);
           this.tranxnForm.controls.BankId.setValue(res.body.data.fields.BankId);
           this.tranxnForm.controls.TerminalId.setValue(res.body.data.fields.TerminalId);
           this.tranxnForm.controls.Version.setValue(res.body.data.fields.Version);
           this.tranxnForm.controls.TransactionId.setValue(res.body.data.fields.TransactionId);
    
           this.EncDataField  	= res.body.data.fields.EncData;
           this.MerchantIdField = res.body.data.fields.MerchantId;
           this.BankIdField = res.body.data.fields.BankId;
           this.TerminalIdField = res.body.data.fields.TerminalId ;
           this.VersionField = res.body.data.fields.Version ;
           this.txnForm.nativeElement.submit();
    
    
          }
          else{
           this.commonUtility.alertMsg(res.body.statusDesc,'',false);
          }
          this.Cap();
          this.loading =false;
            },
                (error)=>{
                  this.Cap();
                    this.commonUtility.alertMsg(JSON.stringify(error.statusText) ,'',false);
                    this.form.controls.captcha.setValue('');
                    this.loading =false;


                  }
          )
        
      }
      
        }

hideError(controlName)
    {
      this.form.controls[controlName].markAsUntouched();
      if(this.submitBtnMsgClass && this.submitBtnMsgClass.indexOf("alertBlock")>-1)
      {  this.submitBtnMsgClass="wrapper"; }
      if(this.submitBtnMsg && this.submitBtnMsg.indexOf("a")>-1)
      { this.submitBtnMsg=""; }
    }  
    
    ValidCaptcha(){
      let str1=this.initialCap
      let str2=this.form.get('captcha').value;
      if(str2.toUpperCase()!="") {
      if(str1 == str2.toUpperCase()){
        this.form.controls['captcha'].setErrors(null);
        return true;
      }else{
        this.form.controls['captcha'].setErrors({'incorrectcaptcha': true});
        return false;
      }
      }
      else {
        this.commonUtility.alertMsg('Please try again invalid Captcha','',false);
      }
    }

    Cap() {
      let alpha = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
       var apl1 = alpha[Math.floor(Math.random() * 36)];
       var apl2 = alpha[Math.floor(Math.random() * 36)];
       var apl3 = alpha[Math.floor(Math.random() * 36)];
       var apl4 = alpha[Math.floor(Math.random() * 36)];
       var apl5 = alpha[Math.floor(Math.random() * 36)];
       var apl6 = alpha[Math.floor(Math.random() * 36)];
       this.initialCap = apl1 + apl2 + apl3 + apl4 + apl5 + apl6;
  
       }

     
}
